import React from 'react';
import { ArrowRight, ChevronDown, Sparkles } from 'lucide-react';
import { heroContent, valuePillars } from '../data/mock';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero grid-pattern" id="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text animate-fadeInUp">
            <div className="hero-badge">
              <Sparkles size={14} />
              <span>Enterprise Engineering Partner</span>
            </div>
            <h1 className="hero-headline">
              Engineering Excellence for{' '}
              <span className="highlight">Tomorrow's Mobility</span>
            </h1>
            <p className="hero-subheadline">
              {heroContent.subheadline}
            </p>
            <div className="hero-buttons">
              <button 
                className="btn-primary glow-effect"
                onClick={() => scrollToSection('#contact')}
              >
                {heroContent.cta}
                <ArrowRight size={16} />
              </button>
              <button 
                className="btn-secondary"
                onClick={() => scrollToSection('#services')}
              >
                {heroContent.secondaryCta}
              </button>
            </div>
          </div>
          
          {/* Animated gradient blob visual */}
          <div className="hero-visual animate-fadeIn delay-300">
            <div className="hero-blob"></div>
            <div className="hero-blob-secondary"></div>
            <div className="hero-blob-tertiary"></div>
          </div>
        </div>
        
        {/* Value Pillars */}
        <div className="pillars-grid">
          {valuePillars.map((pillar, index) => (
            <div 
              key={pillar.title} 
              className="pillar-card animate-fadeInUp"
              style={{ animationDelay: `${(index + 1) * 100}ms` }}
            >
              <h3 className="pillar-title">{pillar.title}</h3>
              <p className="pillar-description">{pillar.description}</p>
            </div>
          ))}
        </div>
        
        {/* Scroll indicator */}
        <div className="flex justify-center mt-12 animate-float">
          <button 
            className="text-[var(--text-muted)] hover:text-[var(--accent-primary)] transition-colors p-2"
            onClick={() => scrollToSection('#about')}
            aria-label="Scroll to about section"
          >
            <ChevronDown size={28} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
